import React from 'react'
import {Link} from 'react-router-dom';
import {FiShoppingBag, FiGift} from "react-icons/fi";
import {GiPayMoney} from "react-icons/gi";
import {MdSecurity} from "react-icons/md";
import {FcOnlineSupport} from "react-icons/fc";
import Marquee from "react-fast-marquee";
import BlogCard from '../ass_components/BlogCard';
import ProductCard from '../ass_components/ProductCard';
import MeilleursVentes from '../ass_components/MeilleursVentes';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from '../i18n';
import AppDownloadSection from '../ass_components/AppDownloadSection';
import EquipmentCard from '../ass_components/EquipmentCard';

const HomePastoral = () => {
  const dispatch = useDispatch();
  const language_code = useSelector((state) => state.lang)
  let productCardProps=[
    { id:1,
      image1:'images/detail-images/detail1.jpg',
      image2:'images/detail-images/detail111.jpg',
      product_title:'Soja alvic',
      star_number:4,
      price:650
    },
    { id:2,
      image1:'images/detail-images/detail22.webp',
      image2:'images/detail-images/detail2.jpg',
      product_title:'Pomme de terre',
      star_number:4,
      price:600
    },
    { id:3,
      image1:'images/detail-images/detail3.webp',
      image2:'images/detail-images/detail33.jpeg',
      product_title:'Fruits et legumes',
      star_number:4,
      price:900
    },
    { id:4,
      image1:'images/detail-images/detail4.jpg',
      image2:'images/detail-images/detail44.webp',
      product_title:'Patate douce',
      star_number:4,
      price:700
    }
  ]

  let meilleursVenteCardProps=[
    { id:1,
      image1:'images/bestseller-images/bestseller1.webp',
      product_category:'Grains',
      product_title:'Riz long',
      progress_bar:'75',
      star_number:5,
      price:650,
      actual_price:650,
      days:1,
      in_stock:'50 tonnes',
      farmers_number:12
    },
    { id:2,
      image1:'images/bestseller-images/bestseller8.jpg',
      product_category:'Grains',
      product_title:'Maïs nouveau',
      progress_bar:'50',
      star_number:4,
      price:600,
      actual_price:650,
      days:3,
      in_stock:'80 tonnes',
      farmers_number:21
    },
    { id:3,
      image1:'images/bestseller-images/bestseller4.jpg',
      product_category:'Fruits',
      product_title:'Ananas',
      progress_bar:'75',
      star_number:5,
      price:900,
      actual_price:650,
      days:2,
      in_stock:'12 tonnes',
      farmers_number:13
    }
  ]

  let blogCardProps=[
    { id:1,
      image:'images/blog-images/delivery1.jpg',
      blog_category:'Grains',
      blog_title:'Livraison 24/72h en moyenne',
      blog_description:"Nos articles sont en cours de révision. Le service de newsletter vous tient au courants des échances futures jusqu'en Septembre. De là vous retrouverez toutes nos publications en ligne à nouveau...",
      publish_date:'12/06/23',
      likes:650,
      views:254,
      update_date:'12/06/23'
    },
    { id:2,
      image:'images/blog-images/security1.png',
      blog_category:'Grains',
      blog_title:'Payement 100% securise en ligne',
      blog_description:"Nos articles sont en cours de révision. Le service de newsletter vous tient au courants des échances futures jusqu'en Septembre. De là vous retrouverez toutes nos publications en ligne à nouveau...",
      publish_date:'12/06/23',
      likes:650,
      views:254,
      update_date:'12/06/23'
    },
    { id:3,
      image:'images/blog-images/quality1.jpg',
      blog_category:'Grains',
      blog_title:'6000 produits de qualite PRO',
      blog_description:"Nos articles sont en cours de révision. Le service de newsletter vous tient au courants des échances futures jusqu'en Septembre. De là vous retrouverez toutes nos publications en ligne à nouveau...",
      publish_date:'12/06/23',
      likes:650,
      views:254,
      update_date:'12/06/23'
    },
    { id:4,
      image:'images/blog-images/collectivity1.png',
      blog_category:'Grains',
      blog_title:'Particulier, Pro & Collectivite',
      blog_description:"Nos articles sont en cours de révision. Le service de newsletter vous tient au courants des échances futures jusqu'en Septembre. De là vous retrouverez toutes nos publications en ligne à nouveau...",
      publish_date:'12/06/23',
      likes:650,
      views:254,
      update_date:'12/06/23'
    }
  ]
  
  const equipmentList = [
  {
    id: "debroussailleuse",
    title: "tête de débroussailleuse",
    subtitle: "multifils-attilina",
    price: "8000 FCFA HT",
    image: "images/equipment-images/tete-de-debroussailleuse-multifils-attilina.jpg"
  },
  {
    id: "fil-debroussaillage",
    title: "fil de débroussaillage",
    subtitle: "pro ellipse bruit",
    price: "9000 FCFA HT",
    image: "images/equipment-images/fil-de-debroussaillage-pro-ellipse-bruit-reduit-25mm-vert-et-noir-blister-de-65m.jpg"
  },
  {
    id: "piquet-de-vigne",
    title: "piquet de vigne",
    subtitle: "intermédiaire",
    price: "11500 FCFA",
    image: "images/equipment-images/piquet-vigne-intermediaire-encoches-lonneo-e01-galva-z275-ep-15-mm-long-180-m-lot-200-unites.jpg"
  },
  {
    id: "ultrason-solaire",
    title: "ultrason solaire",
    subtitle: "répulsif de gibier",
    price: "11500 FCFA",
    image: "images/equipment-images/repulsif-gibier-ultrason-solaire-doxmand-dual-surface-couverte-2-ha.jpg"
  }
  ];
  return (<>
    <section className='assiganto-home-wrapper-1 py-4'>
      <div className='container-xxl'>
        <div className='row'>
          <div className='col-6'>
            <div className='main-banner position-relative'>
              <img src="images/presentation_images/pastoral/picture2.jpg" 
                   className="img-fluid rounded-3" 
                   alt="main-banner"/>
              <div className='main-banner-content-pastoral position-absolute'>
                <h5>{translate('main_banner_pastoral', language_code.lang).main_banner_title}</h5>
                <h4>{translate('main_banner_pastoral', language_code.lang).main_banner_subtitle}</h4>
                <p>{translate('main_banner_pastoral', language_code.lang).main_banner_domain}
                <br/>{translate('main_banner_pastoral', language_code.lang).main_banner_spec}</p>
                <Link className='button' to='/signup'>{translate('main_banner_pastoral', language_code.lang).main_banner_signin}</Link>
              </div>
            </div>            
          </div>  
          <div className='col-6'>
            <div className='d-flex flex-wrap gap-10 justify-content-center align-items-center'>
            <div className='small-banner position-relative'>
              <img src="images/presentation_images/pastoral/picture1.jpg" 
                   className="img-fluid rounded-3" 
                   alt="small-banner"/>
              <div className='small-banner-content-pastoral position-absolute'>
                <h4>{translate('small-banner1-pastoral', language_code.lang).main_banner_title}</h4>
                <h5>{translate('small-banner1-pastoral', language_code.lang).main_banner_subtitle}</h5>
                <p>{translate('small-banner1-pastoral', language_code.lang).main_banner_domain} <br/>
                {translate('small-banner1-pastoral', language_code.lang).main_banner_spec}</p>
              </div> 
            </div>  
            <div className='small-banner position-relative'>
              <img src="images/presentation_images/pastoral/picture3.jpg" 
                   className="img-fluid rounded-3" 
                   alt="small-banner"/>
              <div className='small-banner-content-pastoral position-absolute'>
              <h4>{translate('small-banner2-pastoral', language_code.lang).main_banner_title}</h4>
                <h5>{translate('small-banner2-pastoral', language_code.lang).main_banner_subtitle}</h5>
                <p>{translate('small-banner2-pastoral', language_code.lang).main_banner_domain} <br/>
                {translate('small-banner2-pastoral', language_code.lang).main_banner_spec}</p>
              </div> 
            </div>
            <div className='small-banner position-relative'>
              <img src="images/presentation_images/pastoral/picture5.jpg" 
                   className="img-fluid rounded-3" 
                   alt="small-banner"/>
              <div className='small-banner-content-pastoral position-absolute'>
              <h4>{translate('small-banner3-pastoral', language_code.lang).main_banner_title}</h4>
                <h5>{translate('small-banner3-pastoral', language_code.lang).main_banner_subtitle}</h5>
                <p>{translate('small-banner3-pastoral', language_code.lang).main_banner_domain} <br/>
                {translate('small-banner3-pastoral', language_code.lang).main_banner_spec}</p>
              </div> 
            </div>  
            <div className='small-banner position-relative'>
              <img src="images/presentation_images/pastoral/picture6.jpg"
                   className="img-fluid rounded-3" 
                   alt="small-banner"/>
              <div className='small-banner-content-pastoral position-absolute'>
                <h4>{translate('small-banner4-pastoral', language_code.lang).main_banner_title}</h4>
                <h5>{translate('small-banner4-pastoral', language_code.lang).main_banner_subtitle}</h5>
                <p>{translate('small-banner4-pastoral', language_code.lang).main_banner_domain} <br/>
                {translate('small-banner4-pastoral', language_code.lang).main_banner_spec}</p>
              </div> 
            </div>
            </div>
          </div>         
        </div>        
      </div>
    </section>
     {/* Nouvelle section QRCode */}
        <AppDownloadSection />
    <section className='assiganto-home-wrapper-2 py-4'>    
      <div className='container-xxl'>
        <div className='row'>
          <div className='col-12'>
            <div className='row gy-3'>
              <div className='col-12 col-sm-6 col-md-4 col-lg-2 d-flex align-items-start gap-2'>
                <FiShoppingBag className='fs-3 flex-shrink-0'/>
                <div>
                  <h6>Achat simplifié</h6>
                  <p className='mb-0'>Partout au Togo</p>
                </div>
              </div>
              <div className='col-12 col-sm-6 col-md-4 col-lg-2 d-flex align-items-start gap-2'>
                <FiGift className='fs-3 flex-shrink-0'/>
                <div>
                  <h6>Remise journalière</h6>
                  <p className='mb-0'>Plus de 25%</p>
                </div>
              </div>
              <div className='col-12 col-sm-6 col-md-4 col-lg-2 d-flex align-items-start gap-2'>
                <GiPayMoney className='fs-3 flex-shrink-0'/>
                <div>
                  <h6>Meilleurs prix</h6>
                  <p className='mb-0'>Au prix des fermiers</p>
                </div>
              </div>
              <div className='col-12 col-sm-6 col-md-4 col-lg-2 d-flex align-items-start gap-2'>
                <MdSecurity className='fs-3 flex-shrink-0'/>
                <div>
                  <h6>Paiement sécurisé</h6>
                  <p className='mb-0'>100% sécurisé</p>
                </div>
              </div>
              <div className='col-12 col-sm-6 col-md-4 col-lg-2 d-flex align-items-start gap-2'>
                <FcOnlineSupport className='fs-3 flex-shrink-0'/>
                <div>
                  <h6>Service client 24/7</h6>
                  <p className='mb-0'>Aide d'un expert</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className='assiganto-home-wrapper-2 py-4'>
      <div className='container-xxl'>
        <div className='row'>
          <div className='col-12'>
            <div className='categories d-flex flex-wrap justify-content-between align-items-center'>
              <div className='d-flex flex-column'>
                <div>
                  <h6>Les céréales</h6>
                <Link className='farmers-link'>
                  31 producteurs
                </Link>
                </div>
                <img src='images/specimen-images/cereale4.jpg' className='img-fluid' alt='produits cerealiers' />
              </div>
              <div className='d-flex flex-column'>
                <div>
                  <h6>Les légumes</h6>
                  <Link className='farmers-link'>
                  54 producteurs
                </Link>
                </div>
                <img src='images/specimen-images/legume1.jpg' className='img-fluid' alt='legumes et fruits' />
              </div>
              <div className='d-flex flex-column'>
                <div>
                  <h6>Les tubercules</h6>
                <Link className='farmers-link'>
                  27 producteurs
                </Link>
                </div>
                <img src='images/specimen-images/tubercule3.webp' className='img-fluid' alt='tubercules' />
              </div>
              <div className='d-flex flex-column'>
                <div>
                  <h6>Matières premières</h6>
                <Link className='farmers-link'>
                  11 producteurs
                </Link>
                </div>
                <img src='images/specimen-images/coton1.jpg'  className='img-fluid' alt='coton' />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="special-wrapper assiganto-home-wrapper-2 py-4">
      <div className='container-xxl'>
        <div className='row'>
          <div className=''>
            <div className='col-12'>
              <h3 className='section-heading'>Les offres du moment</h3>
            </div>
            <div className='row'>
              {meilleursVenteCardProps.map((item, index) => (
                   <MeilleursVentes {...item}/>))}
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className='featured-wrapper assiganto-home-wrapper-2 py-4'>
      <div className='container-xxl'>
        <div className='row'>
          <div className='col-12'>
            <h3 className='section-heading'>Disponible chez les détaillants</h3>
          </div>
          {productCardProps.map((item, index) => (

                <ProductCard {...item}/>

            ))}

        </div>
      </div>
    </section>
    
    <section className='famous-wrapper assiganto-home-wrapper-2 py-4'>
      <div className="container-xxl">
        <div className='row'>
          <div className='col-12 mb-3'>
            <h3 className='section-heading'>Équipements agricoles</h3>
          </div>

          {equipmentList.map((item, index) => (
            <div key={index} className='col-12 col-sm-6 col-md-4 col-lg-3 mb-4'>
              <EquipmentCard {...item} />
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className='marque-wrapper assiganto-home-wrapper-2 py-4'>
      <div className='container-xxl'>
        <div className='row'>
          <div className='col-12'>
            <div className='marquee-inner-wrapper card-wrapper'>
              <Marquee>
                <div className='mx-4 w-45'>
                <img src='images/payment-method-icons/floozNoColor.png' 
                   className='img-fluid' 
                   alt='famous' />
                </div>
                <div className='mx-4 w-45'>
                <img src='images/payment-method-icons/paypalNoColor.png' 
                   className='img-fluid' 
                   alt='famous' />
                </div>
                <div className='mx-4 w-45'>
                <img src='images/payment-method-icons/masterNoColor.png' 
                   className='img-fluid' 
                   alt='famous' />
                </div>
                <div className='mx-4 w-45'>
                <img src='images/payment-method-icons/ecoNoColor.png' 
                   className='img-fluid' 
                   alt='famous' />
                </div>
                <div className='mx-4 w-45'>
                <img src='images/payment-method-icons/worldNoColor.png' 
                   className='img-fluid' 
                   alt='famous' />
                </div>
              </Marquee>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className='blog-wrapper h-100 assiganto-home-wrapper-2 py-4'>
      <div className='container-xxl'>
        <div className='row'>
          <div className='col-12'>
            <h3 className='section-heading'>Actualités récentes</h3>
          </div>
          {blogCardProps.map((item, index) => (
            <div key={index} className='col-12 col-sm-6 col-md-4 col-lg-3 mb-4'>
              <BlogCard {...item} />
            </div>
          ))} 
        </div>
      </div>
    </section>

  </>
    
  )
}
export default HomePastoral